module.exports = __webpack_public_path__ + "img/Project.40216bb8.svg";